
var colors = {

  "red": {
    "s_50": "#ffebee",
    "s_100": "#ffcdd2",
    "s_200": "#ef9a9a",
    "s_300": "#e57373",
    "s_400": "#ef5350",
    "s_500": "#f44336",
    "s_600": "#e53935",
    "s_700": "#d32f2f",
    "s_800": "#c62828",
    "s_900": "#b71c1c",
    "s_A100": "#ff8a80",
    "s_A200": "#ff5252",
    "s_A400": "#ff1744",
    "s_A700": "#d50000"
  },

  "pink": {
    "s_50": "#fce4ec",
    "s_100": "#f8bbd0",
    "s_200": "#f48fb1",
    "s_300": "#f06292",
    "s_400": "#ec407a",
    "s_500": "#e91e63",
    "s_600": "#d81b60",
    "s_700": "#c2185b",
    "s_800": "#ad1457",
    "s_900": "#880e4f",
    "s_A100": "#ff80ab",
    "s_A200": "#ff4081",
    "s_A400": "#f50057",
    "s_A700": "#c51162"
  },

  "purple": {
    "s_50": "#f3e5f5",
    "s_100": "#e1bee7",
    "s_200": "#ce93d8",
    "s_300": "#ba68c8",
    "s_400": "#ab47bc",
    "s_500": "#9c27b0",
    "s_600": "#8e24aa",
    "s_700": "#7b1fa2",
    "s_800": "#6a1b9a",
    "s_900": "#4a148c",
    "s_A100": "#ea80fc",
    "s_A200": "#e040fb",
    "s_A400": "#d500f9",
    "s_A700": "#aa00ff"
  },

  "deepPurple": {
    "s_50": "#ede7f6",
    "s_100": "#d1c4e9",
    "s_200": "#b39ddb",
    "s_300": "#9575cd",
    "s_400": "#7e57c2",
    "s_500": "#673ab7",
    "s_600": "#5e35b1",
    "s_700": "#512da8",
    "s_800": "#4527a0",
    "s_900": "#311b92",
    "s_A100": "#b388ff",
    "s_A200": "#7c4dff",
    "s_A400": "#651fff",
    "s_A700": "#6200ea"
  },

  "indigo": {
    "s_50": "#e8eaf6",
    "s_100": "#c5cae9",
    "s_200": "#9fa8da",
    "s_300": "#7986cb",
    "s_400": "#5c6bc0",
    "s_500": "#3f51b5",
    "s_600": "#3949ab",
    "s_700": "#303f9f",
    "s_800": "#283593",
    "s_900": "#1a237e",
    "s_A100": "#8c9eff",
    "s_A200": "#536dfe",
    "s_A400": "#3d5afe",
    "s_A700": "#304ffe"
  },

  "blue": {
    "s_50": "#e3f2fd",
    "s_100": "#bbdefb",
    "s_200": "#90caf9",
    "s_300": "#64b5f6",
    "s_400": "#42a5f5",
    "s_500": "#2196f3",
    "s_600": "#1e88e5",
    "s_700": "#1976d2",
    "s_800": "#1565c0",
    "s_900": "#0d47a1",
    "s_A100": "#82b1ff",
    "s_A200": "#448aff",
    "s_A400": "#2979ff",
    "s_A700": "#2962ff"
  },

  "lightBlue": {
    "s_50": "#e1f5fe",
    "s_100": "#b3e5fc",
    "s_200": "#81d4fa",
    "s_300": "#4fc3f7",
    "s_400": "#29b6f6",
    "s_500": "#03a9f4",
    "s_600": "#039be5",
    "s_700": "#0288d1",
    "s_800": "#0277bd",
    "s_900": "#01579b",
    "s_A100": "#80d8ff",
    "s_A200": "#40c4ff",
    "s_A400": "#00b0ff",
    "s_A700": "#0091ea"
  },

  "cyan": {
    "s_50": "#e0f7fa",
    "s_100": "#b2ebf2",
    "s_200": "#80deea",
    "s_300": "#4dd0e1",
    "s_400": "#26c6da",
    "s_500": "#00bcd4",
    "s_600": "#00acc1",
    "s_700": "#0097a7",
    "s_800": "#00838f",
    "s_900": "#006064",
    "s_A100": "#84ffff",
    "s_A200": "#18ffff",
    "s_A400": "#00e5ff",
    "s_A700": "#00b8d4"
  },

  "teal": {
    "s_50": "#e0f2f1",
    "s_100": "#b2dfdb",
    "s_200": "#80cbc4",
    "s_300": "#4db6ac",
    "s_400": "#26a69a",
    "s_500": "#009688",
    "s_600": "#00897b",
    "s_700": "#00796b",
    "s_800": "#00695c",
    "s_900": "#004d40",
    "s_A100": "#a7ffeb",
    "s_A200": "#64ffda",
    "s_A400": "#1de9b6",
    "s_A700": "#00bfa5"
  },

  "green": {
    "s_50": "#e8f5e9",
    "s_100": "#c8e6c9",
    "s_200": "#a5d6a7",
    "s_300": "#81c784",
    "s_400": "#66bb6a",
    "s_500": "#4caf50",
    "s_600": "#43a047",
    "s_700": "#388e3c",
    "s_800": "#2e7d32",
    "s_900": "#1b5e20",
    "s_A100": "#b9f6ca",
    "s_A200": "#69f0ae",
    "s_A400": "#00e676",
    "s_A700": "#00c853"
  },

  "lightGreen": {
    "s_50": "#f1f8e9",
    "s_100": "#dcedc8",
    "s_200": "#c5e1a5",
    "s_300": "#aed581",
    "s_400": "#9ccc65",
    "s_500": "#8bc34a",
    "s_600": "#7cb342",
    "s_700": "#689f38",
    "s_800": "#558b2f",
    "s_900": "#33691e",
    "s_A100": "#ccff90",
    "s_A200": "#b2ff59",
    "s_A400": "#76ff03",
    "s_A700": "#64dd17"
  },

  "lime": {
    "s_50": "#f9fbe7",
    "s_100": "#f0f4c3",
    "s_200": "#e6ee9c",
    "s_300": "#dce775",
    "s_400": "#d4e157",
    "s_500": "#cddc39",
    "s_600": "#c0ca33",
    "s_700": "#afb42b",
    "s_800": "#9e9d24",
    "s_900": "#827717",
    "s_A100": "#f4ff81",
    "s_A200": "#eeff41",
    "s_A400": "#c6ff00",
    "s_A700": "#aeea00"
  },

  "yellow": {
    "s_50": "#fffde7",
    "s_100": "#fff9c4",
    "s_200": "#fff59d",
    "s_300": "#fff176",
    "s_400": "#ffee58",
    "s_500": "#ffeb3b",
    "s_600": "#fdd835",
    "s_700": "#fbc02d",
    "s_800": "#f9a825",
    "s_900": "#f57f17",
    "s_A100": "#ffff8d",
    "s_A200": "#ffff00",
    "s_A400": "#ffea00",
    "s_A700": "#ffd600"
  },

  "amber": {
    "s_50": "#fff8e1",
    "s_100": "#ffecb3",
    "s_200": "#ffe082",
    "s_300": "#ffd54f",
    "s_400": "#ffca28",
    "s_500": "#ffc107",
    "s_600": "#ffb300",
    "s_700": "#ffa000",
    "s_800": "#ff8f00",
    "s_900": "#ff6f00",
    "s_A100": "#ffe57f",
    "s_A200": "#ffd740",
    "s_A400": "#ffc400",
    "s_A700": "#ffab00"
  },

  "orange": {
    "s_50": "#fff3e0",
    "s_100": "#ffe0b2",
    "s_200": "#ffcc80",
    "s_300": "#ffb74d",
    "s_400": "#ffa726",
    "s_500": "#ff9800",
    "s_600": "#fb8c00",
    "s_700": "#f57c00",
    "s_800": "#ef6c00",
    "s_900": "#e65100",
    "s_A100": "#ffd180",
    "s_A200": "#ffab40",
    "s_A400": "#ff9100",
    "s_A700": "#ff6d00"
  },

  "deepOrange": {
    "s_50": "#fbe9e7",
    "s_100": "#ffccbc",
    "s_200": "#ffab91",
    "s_300": "#ff8a65",
    "s_400": "#ff7043",
    "s_500": "#ff5722",
    "s_600": "#f4511e",
    "s_700": "#e64a19",
    "s_800": "#d84315",
    "s_900": "#bf360c",
    "s_A100": "#ff9e80",
    "s_A200": "#ff6e40",
    "s_A400": "#ff3d00",
    "s_A700": "#dd2c00"
  },

  "brown": {
    "s_50": "#efebe9",
    "s_100": "#d7ccc8",
    "s_200": "#bcaaa4",
    "s_300": "#a1887f",
    "s_400": "#8d6e63",
    "s_500": "#795548",
    "s_600": "#6d4c41",
    "s_700": "#5d4037",
    "s_800": "#4e342e",
    "s_900": "#3e2723"
  },

  "grey": {
    "s_50": "#fafafa",
    "s_100": "#f5f5f5",
    "s_200": "#eeeeee",
    "s_300": "#e0e0e0",
    "s_400": "#bdbdbd",
    "s_500": "#9e9e9e",
    "s_600": "#757575",
    "s_700": "#616161",
    "s_800": "#424242",
    "s_900": "#212121"
  },

  "blueGrey": {
    "s_50": "#eceff1",
    "s_100": "#cfd8dc",
    "s_200": "#b0bec5",
    "s_300": "#90a4ae",
    "s_400": "#78909c",
    "s_500": "#607d8b",
    "s_600": "#546e7a",
    "s_700": "#455a64",
    "s_800": "#37474f",
    "s_900": "#263238"
  },

  "black": "#000000",
  "white": "#FFFFFF"
}

export default colors



// WEBPACK FOOTER //
// ./src/client/lib/colors.js